<template>
    <div class="loader-wrap">
        <p class="caption">
            {{localCaption}}
        </p>

        <div class="progress-wrap">
            <div class="progress-wrap__train"></div>
        </div>

        <p  v-if="showInfoText"
            class="info-text"
        >
            {{info}}
        </p>
    </div>
</template>

<script>
export default {
  props: {
    caption: {
      type: String,
      default: ''
    },

    info: {
      type: String,
      default: ''
    }
  },

  computed: {
    localCaption () {
      return _.trim(this.caption)
    },

    showInfoText () {
      return !_.isEmpty(this.info)
    }
  }
}
</script>

<style lang="scss" scoped>
    .loader-wrap {
        display: flex;
        flex-direction: column;
        width: 320px;
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translateX(-50%);

        .caption {
            font-weight: bold;
            color: $or-black-blue;
            font-size: 18px;
            text-align: center;
            margin: 0;
        }

        .progress-wrap {
            position: relative;
            overflow: hidden;
            width: 100%;
            height: 4px;
            background-color: #DFDFDF;
            border-radius: 4px;
            margin-top: 10px;

            &__train {
                position: absolute;
                left: 0;
                top: 0;
                width: 25%;
                height: 4px;
                animation: train .8s infinite linear;
                background-color: #409FEC;
                border-radius: 4px;

                @keyframes train {
                    0%   { left: -25%; }
                    100% { left: 100%; }
                }
            }
        }

        .info-text {
            margin: 8px 0 0;
            font-size: 14px;
            font-weight: normal;
            text-align: center;
            color: #0F232E;

        }
    }
</style>
